import { render, staticRenderFns } from "./testpage.vue?vue&type=template&id=2758ab52&scoped=true&"
import script from "./testpage.vue?vue&type=script&lang=js&"
export * from "./testpage.vue?vue&type=script&lang=js&"
import style0 from "./testpage.vue?vue&type=style&index=0&id=2758ab52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2758ab52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2758ab52')) {
      api.createRecord('2758ab52', component.options)
    } else {
      api.reload('2758ab52', component.options)
    }
    module.hot.accept("./testpage.vue?vue&type=template&id=2758ab52&scoped=true&", function () {
      api.rerender('2758ab52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/testpage.vue"
export default component.exports